<div class="bg-[#F5F5F5]">
    <div class="flex flex-col justify-between min-h-screen">
        <div>
            <ng-container *ngTemplateOutlet="header"></ng-container>
        </div>
        <div class="grow mx-[20px]">
            <ng-container *ngTemplateOutlet="body"></ng-container>
        </div>
        <div class="mx-[20px]">
            <ng-container *ngTemplateOutlet="footer"></ng-container>
        </div>
    </div>
</div>


<ng-template #header>
    <app-mobile-timeline-template-v2
            (goBack)="goBack()"
            [previous]="usernameNumberTimeline?.previousTitle"
            [currentStep]="usernameNumberTimeline?.step"
            [total]="timelines?.length"
            [version]="CustomTimelineVersion.version_8"
            [description]="usernameNumberTimeline?.description"
            [title]="usernameNumberTimeline?.previousTitle">
    </app-mobile-timeline-template-v2>
</ng-template>
<ng-template #body>
    <div class="flex bg-white rounded-[12px] px-[16px] py-[24px] justify-center">
        <div class="grow">
            <app-kamona-input-field
                    (emitInput)="setUsername($event)"
                    [input]="username">
            </app-kamona-input-field>
        </div>
    </div>
</ng-template>
<ng-template #footer>
    <div class="pb-[40px]">
        <div class="kamona-button-session pt-[24px]">
            <app-kamona-custom-button
                    [isDisabled]="!disableUsernameButton"
                    [isSubmitting]="submitting"
                    type="primary"
                    (submitForm)="submit()"
                    [isBlock]="true" text="Next">
            </app-kamona-custom-button>
        </div>
    </div>
</ng-template>

